import { all, select, takeLatest } from "redux-saga/effects";
import { getCommonSaga } from "../sagaUtils";
import store from "../index";
import {
  agentCreateFailure,
  agentCreateSuccess,
  agentDeleteFailure,
  agentDeleteSuccess,
  agentInviteFailure,
  agentInviteSuccess,
  agentListFailure,
  agentListSuccess,
  agentUpdateFailure,
  agentUpdateSuccess,
} from "../slices/AgentSlice";

function* agentListAPI(action) {
  yield getCommonSaga({
    apiUrl: "merchant_agents",
    payload: action.payload,
    successNotify: false,
    success: agentListSuccess,
    failure: agentListFailure,
  });
}

function* agentCreateAPI(action) {
  const agentListData = yield select((state) => state.agent.agentList.data);
  const hasAgentList =
    agentListData &&
    Object.keys(agentListData).length > 0 &&
    Array.isArray(agentListData.agents);

  yield getCommonSaga({
    apiUrl: "merchant_agents/store",
    payload: action.payload,
    successNotify: true,
    successCallback: true,
    success: (data) => {
      store.dispatch(agentCreateSuccess({ data }));
      if (hasAgentList) {
        store.dispatch(
          agentListSuccess({
            ...agentListData,
            agents: [data.agent, ...agentListData.agents],
            total_agents: (agentListData.total_agents || 0) + 1,
          })
        );
      }
    },
    failure: agentCreateFailure,
  });
}

function* agentUpdateAPI(action) {
  const agentListData = yield select((state) => state.agent.agentList.data);
  const hasAgentList =
    agentListData &&
    Object.keys(agentListData).length > 0 &&
    Array.isArray(agentListData.agents);

  yield getCommonSaga({
    apiUrl: "merchant_agents/update",
    payload: action.payload,
    successNotify: true,
    successCallback: true,
    success: (data) => {
      store.dispatch(agentUpdateSuccess({ data }));
      if (hasAgentList) {
        store.dispatch(
          agentListSuccess({
            ...agentListData,
            agents: agentListData.agents.map((agent) =>
              agent.id === data.agent.id ? { ...agent, ...data.agent } : agent
            ),
          })
        );
      }
    },
    failure: agentUpdateFailure,
  });
}

function* agentInviteAPI(action) {
  yield getCommonSaga({
    apiUrl: "merchant_agents/send_invite",
    payload: action.payload,
    successNotify: true,
    success: agentInviteSuccess,
    failure: agentInviteFailure,
  });
}

function* agentDeleteAPI(action) {
  const agentListData = yield select((state) => state.agent.agentList.data);
  const hasAgentList =
    agentListData &&
    Object.keys(agentListData).length > 0 &&
    Array.isArray(agentListData.agents);

  yield getCommonSaga({
    apiUrl: "merchant_agents/destroy",
    payload: action.payload,
    successNotify: true,
    successCallback: true,
    success: (data) => {
      store.dispatch(agentDeleteSuccess({ data }));
      if (hasAgentList) {
        store.dispatch(
          agentListSuccess({
            ...agentListData,
            agents: agentListData.agents.filter(
              (agent) => agent.id !== action.payload.merchant_agent_id
            ),
            total_agents: Math.max((agentListData.total_agents || 1) - 1, 0),
          })
        );
      }
    },
    failure: agentDeleteFailure,
  });
}

export default function* AgentSaga() {
  yield all([
    yield takeLatest("agent/agentListStart", agentListAPI),
    yield takeLatest("agent/agentCreateStart", agentCreateAPI),
    yield takeLatest("agent/agentUpdateStart", agentUpdateAPI),
    yield takeLatest("agent/agentInviteStart", agentInviteAPI),
    yield takeLatest("agent/agentDeleteStart", agentDeleteAPI),
  ]);
}
